//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
import uniRate from "@/components/uni-rate/uni-rate.vue"
import moment from 'dayjs'
export default {
  data() {
    return {
      end: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        count: 0,
        // name: '',
        loading: false,
        finished: false
      },
      noHead: '/static/comment/noHead.png',
      dataObj: 0,
      commentList: [],
      productId: '',
      bodyId: ''
    }
  },
  components: {
    uniLoadMore, uniRate
  },
  onLoad(event) {
    this.productId = event.productId || ''
    this.bodyId = event.bodyId || ''
  },
  onReady() {
    this.queryData()
  },
  onPullDownRefresh() {
    this.list = []
    this.page.currentPage = 1
    this.queryData('refresh')
  },
  onReachBottom() {
    if (this.list.length < this.page.count) {
      this.queryData()
    }
  },
  methods: {
    queryData(status) {
      this.page.loading = true
      this.$ajax({
        method: 'post',
        url: '/weChat/comment/list',
        data: {
          ...this.page,
          productId: this.productId,
          bodyId: this.bodyId,
          commentatorId: this.$store.state.userInfo.memberId || ''
        }
      }).then(data => {
        this.page.count = data.count
        data.data.forEach(element => {
          element.createTime = moment(element.createTime).format('YYYY-MM-DD')
          if (element.isCryptonym === 1) {
            element.memberName = '匿名用户'
            element.headImage = this.noHead
          }
          if (element.headImage === '') {
            element.headImage = this.noHead
          }
        })
        this.dataObj = parseFloat(data.dataObj || 0)
        this.commentList.push.apply(this.commentList, data.data)
        if (this.commentList.length >= this.page.count) {
          this.end = true
        }
        this.page.currentPage += 1
        if (status === 'refresh') {
          uni.stopPullDownRefresh();
        }
        this.page.loading = false
      })
    },
    refresh() {
      this.page.currentPage = 1
      this.commentList = []
      this.queryData()
    }
  }
}
